import type { ApolloClient } from 'apollo-client';

import { createClient } from './createClient';

interface GetApolloClientOptions {
	initializeNewCache?: boolean;
	batchInterval?: number;
	batchSize?: number;
}
// Make sure there is only one client being created in the app
let apolloClient: ApolloClient<any> | null = null;
export function getApolloClient({
	initializeNewCache = false,
}: GetApolloClientOptions = {}): ApolloClient<any> {
	// Ensure tests are using the same apollo client.
	// Also allow query in @confluence/query-preloader to use apollo without direct dependency.
	if (window['GLOBAL_APOLLO_CLIENT']) {
		return window['GLOBAL_APOLLO_CLIENT'];
	}
	if (!apolloClient) {
		apolloClient = createClient({ initializeNewCache });
	}
	window['GLOBAL_APOLLO_CLIENT'] = apolloClient!;
	return apolloClient!;
}
